import React from "react";

const ErrorModal = ({ setSubmittedValues, message, isAPIError }) => {
    return (
        <div className="modal errorModal">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            {isAPIError ? "Error" : "Success"}
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={() => setSubmittedValues(false)}
                        />
                    </div>
                    <div className="modal-body">
                        <p>
                            {message ||
                                "Error while submitting data, please try again."}
                        </p>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => setSubmittedValues(false)}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ErrorModal;
